/* PWW v65: merchandising polish for wheel and tire product cards. */
(function () {
  function normalizeText(value) {
    return String(value || '')
      .replace(/&amp;/g, '&')
      .replace(/[“”]/g, '"')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function titleFromItem(item) {
    if (item.dataset.pwwProductTitle) return normalizeText(item.dataset.pwwProductTitle);
    var link = item.querySelector('.card__heading a, .full-unstyled-link');
    return link ? normalizeText(link.textContent) : '';
  }

  function cleanModelText(value) {
    return normalizeText(value)
      .replace(/\b(?:wheel|wheels|rim|rims|fast wheels|project wheel works)\b/gi, ' ')
      .replace(/\b\d+\s*x\s*\d{3}(?:\.\d+)?\s*(?:mm)?\b/gi, ' ')
      .replace(/\b\d+(?:\.\d+)?\s*mm\b/gi, ' ')
      .replace(/\s*\/\s*/g, ' ')
      .replace(/[^a-z0-9-]+/gi, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function parseWheel(title) {
    var normalized = normalizeText(title);
    var sizeMatch = normalized.match(/\b(\d{2})\s*x\s*(\d+(?:\.\d+)?)\b/i);
    if (!sizeMatch) return null;

    var model = cleanModelText(normalized.slice(0, sizeMatch.index));
    var rest = normalized.slice(sizeMatch.index + sizeMatch[0].length);
    var bolt = rest.match(/\b\d+\s*x\s*\d{3}(?:\.\d+)?\s*(?:mm)?\b/i);
    var offset = rest.match(/\b(?:ET|offset)\s*[-+]?\d+\b/i);
    var bore = rest.match(/\b(?:\d+(?:\.\d+)?\s*(?:mm)?\s*)?(?:bore|hub|cb)\b/i);
    var finish = rest
      .replace(/\b\d+\s*x\s*\d{3}(?:\.\d+)?\s*(?:mm)?\b/gi, ' ')
      .replace(/\b(?:ET|offset)\s*[-+]?\d+\b/gi, ' ')
      .replace(/\b(?:cb|hub|bore|center bore|centre bore)\s*[:/-]?\s*\d+(?:\.\d+)?\s*(?:mm)?\b/gi, ' ')
      .replace(/\b\d+(?:\.\d+)?\s*(?:mm)?\s*(?:cb|hub|bore|center bore|centre bore)\b/gi, ' ')
      .replace(/\b(?:wheel|wheels|rim|rims)\b/gi, ' ')
      .replace(/\s+/g, ' ')
      .trim();

    return {
      type: 'wheel',
      title: [model, finish, sizeMatch[1] + 'x' + String(parseFloat(sizeMatch[2]))].filter(Boolean).join(' '),
      specs: [bolt && bolt[0].replace(/\s+/g, '').replace(/mm$/i, ''), offset && offset[0].replace(/^offset\s*/i, 'ET'), bore && bore[0].replace(/\s+/g, ' ')].filter(Boolean)
    };
  }

  function parseTire(title) {
    var normalized = normalizeText(title);
    var sizeMatch = normalized.match(/\b\d{3}\/\d{2}R\d{2}\b/i);
    if (!sizeMatch) return null;

    var before = normalized.slice(0, sizeMatch.index).trim();
    var after = normalized.slice(sizeMatch.index + sizeMatch[0].length);
    var loadSpeed = after.match(/\b\d{2,3}[A-Z]\b/i);
    var season = after.match(/\b(?:winter|all[-\s]?weather|all[-\s]?season|performance|mud terrain|all terrain)\b/i);

    return {
      type: 'tire',
      title: [before, sizeMatch[0].toUpperCase()].filter(Boolean).join(' '),
      specs: [loadSpeed && loadSpeed[0].toUpperCase(), season && season[0].replace('-', ' ')].filter(Boolean)
    };
  }

  function setCardTitle(item, displayTitle) {
    item.querySelectorAll('.card__heading a').forEach(function (link) {
      link.textContent = displayTitle;
    });
  }

  function ensureSpecs(info, specs) {
    if (!specs.length || info.querySelector('.pww-card-polish-specs')) return;
    var specWrap = document.createElement('div');
    specWrap.className = 'pww-card-polish-specs';
    specs.slice(0, 4).forEach(function (spec) {
      var chip = document.createElement('span');
      chip.textContent = spec;
      specWrap.appendChild(chip);
    });
    info.insertBefore(specWrap, info.querySelector('.price') || null);
  }

  function polishCards() {
    document.querySelectorAll('#product-grid > .grid__item, .product-grid > .grid__item').forEach(function (item) {
      if (item.dataset.pwwCardPolished === 'true') return;

      var originalTitle = titleFromItem(item);
      if (!originalTitle) return;

      var parsed = parseWheel(originalTitle) || parseTire(originalTitle);
      if (!parsed) return;

      var info = item.querySelector('.card-information');
      if (!info) return;

      item.dataset.pwwCardPolished = 'true';
      item.dataset.pwwProductKind = parsed.type;
      setCardTitle(item, parsed.title);
      ensureSpecs(info, parsed.specs);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', polishCards);
  } else {
    polishCards();
  }

  document.addEventListener('shopify:section:load', polishCards);
  document.addEventListener('facet:updated', polishCards);

  var observer = new MutationObserver(function (mutations) {
    if (mutations.some(function (mutation) { return mutation.addedNodes.length; })) {
      window.requestAnimationFrame(polishCards);
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
